// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-tournament-teams-list__container{
    margin-top: 14px;
    padding: 27px 30px;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    border-radius: 14px;
}
.page-tournament-teams-list__title.baloa-subtitle-2{
    color: var(--primary-dark-color); 
    padding-bottom: 14px;
}

.page-tournament-teams-list__image{
    width: 39px;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.page-tournament-teams-list__image img{
    width: 39px;
    height: 39px;
    border-radius: 50%;
}

.page-tournament-teams-list__image .icon-ball{
    color: var(--white-color);
    font-size: 29px;
    padding: 5px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.page-tournament-teams-list {
    display: flex;
    align-items: center;
    margin-bottom: var(--space);
}
.page-tournament-teams-list__data {
    margin-left: var(--space-half);
}

.page-tournament-teams-list__data div:first-of-type {
    margin-bottom: var(--space-quarter);
}

.page-tournament-teams-list__data div:last-of-type {
    margin-top: var(--space-quarter);
}

.page-tournament-teams-list {
    cursor: pointer;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .page-tournament-teams-list__container{
        margin:12px
    }

}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/page-tournament-teams-list/PageTournamentTeamsListComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,iDAAiD;IACjD,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI;IACJ;;AAEJ","sourcesContent":[".page-tournament-teams-list__container{\n    margin-top: 14px;\n    padding: 27px 30px;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    border-radius: 14px;\n}\n.page-tournament-teams-list__title.baloa-subtitle-2{\n    color: var(--primary-dark-color); \n    padding-bottom: 14px;\n}\n\n.page-tournament-teams-list__image{\n    width: 39px;\n    height: 39px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.page-tournament-teams-list__image img{\n    width: 39px;\n    height: 39px;\n    border-radius: 50%;\n}\n\n.page-tournament-teams-list__image .icon-ball{\n    color: var(--white-color);\n    font-size: 29px;\n    padding: 5px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.page-tournament-teams-list {\n    display: flex;\n    align-items: center;\n    margin-bottom: var(--space);\n}\n.page-tournament-teams-list__data {\n    margin-left: var(--space-half);\n}\n\n.page-tournament-teams-list__data div:first-of-type {\n    margin-bottom: var(--space-quarter);\n}\n\n.page-tournament-teams-list__data div:last-of-type {\n    margin-top: var(--space-quarter);\n}\n\n.page-tournament-teams-list {\n    cursor: pointer;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .page-tournament-teams-list__container{\n        margin:12px\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
